import React from 'react';
import FacebookShareWidget from "../FacebookShareWidget/FacebookShareWidget.jsx";
import TwitterShareWidget from "../TwitterShareWidget/TwitterShareWidget.jsx";
//import shortid from 'shortid';
export default class ShareWidget extends React.Component {
    constructor(props) {
        super(props);
        this.props=props;
        this.state = {
            hovered:false,
            maskid:"hole_"+"share_"+(props.uniqueId || '1'),
            expanded: false
        };
        
        this.handleMouseOver=this.handleMouseOver.bind(this);
        this.handleMouseOut=this.handleMouseOut.bind(this);
    }
    componentDidMount() {
        this.refs.thecircle.setAttribute("mask","url(#" + this.state.maskid + ")");                
    }
    handleMouseOver() {
        this.setState({hovered:true});
    }
    handleMouseOut() {
        this.setState({hovered:false});
    }
    render() {
        var props=this.props;
        var symbolstroke = (this.state.hovered&&this.props.highlightMode=="inner")?"#e51c23":"none";
        return(
            <span>
                <span 
                    onMouseOver = {this.handleMouseOver} 
                    onMouseOut = {this.handleMouseOut} 
                    onClick = {()=> this.setState({expanded: !this.state.expanded })} 
                    className = {"btn-floating waves-effect waves-light"}
                    style= {{backgroundColor:"#f2f2f2!important"}}
                >
                    <svg width="100%" height={props.size||null} viewBox="0 0 32 32">
                        <defs>
                            <mask id={this.state.maskid}>
                                <rect width="100%" height="100%" fill="white"/>
                                <g>
                                    <g transform="translate(-2)">
                                        <line x1="21.24" y1="10.88" x2="12.78" y2="15.11" fill="none" stroke="#000" stroke-miterlimit="10" strokeWidth="1.6"/>
                                        <line x1="21.45" y1="21.27" x2="12.78" y2="16.9" fill="none" stroke="#000" stroke-miterlimit="10" strokeWidth="1.6"/>
                                        <circle cx="23" cy="10" r="2" stroke="#000" fill="#000" strokeMiterlimit="10" strokeWidth="1.8"/>
                                        <circle cx="23.12" cy="22.12" r="1.88" stroke="#000" fill="#000" strokeMiterlimit="10" strokeWidth="1.8"/>
                                        <circle cx="11" cy="16" r="2" stroke="#000" fill="#000" strokeMiterlimit="10" strokeWidth="1.8"/>
                                    </g>
                                </g>
                            </mask>
                        </defs>
                        <circle ref="thecircle" cx="16" cy="16" r="15" mask={"url(#" + this.state.maskid + ")"}
                            style={{
                                fill:(this.state.hovered&&this.props.highlightMode=="outer")?"#e51c23":"#2b2b2b"     
                            }}
                        />
                        <g>
                            <g ref="thesymbol" transform="translate(-2)">
                                <line x1="21.24" y1="10.88" x2="12.78" y2="15.11" fill="none" stroke={symbolstroke} stroke-miterlimit="10" strokeWidth="1.6"/>
                                <line x1="21.45" y1="21.27" x2="12.78" y2="16.9" fill="none" stroke={symbolstroke} stroke-miterlimit="10" strokeWidth="1.6"/>
                                <circle cx="23" cy="10" r="2" stroke={symbolstroke} fill={symbolstroke} strokeMiterlimit="10" strokeWidth="1.8"/>
                                <circle cx="23.12" cy="22.12" r="1.88" stroke={symbolstroke} fill={symbolstroke} strokeMiterlimit="10" strokeWidth="1.8"/>
                                <circle cx="11" cy="16" r="2" stroke={symbolstroke} fill={symbolstroke} strokeMiterlimit="10" strokeWidth="1.8"/>
                            </g>
                        </g>
                    </svg>    
                </span>
                <div style={{
                    display: (this.state.expanded?"block":"none"),
                    position: "absolute"
                    }}>
                    <div style={{marginTop:"2px"}} />
                    {this.props.children}                
                </div>
            </span>    
        );
    }
}


/*<g ref="thesymbol" transform="translate(1)">
    <line x1="11.76" y1="10.88" x2="20.22" y2="15.11" fill="none" stroke={symbolstroke} strokeMiterlimit="10" strokeWidth="1.8"/>
    <line x1="11.55" y1="21.27" x2="20.22" y2="16.9" fill="none" stroke={symbolstroke} strokeMiterlimit="10" strokeWidth="1.8"/>
    <circle cx="10" cy="10" r="2" fill="none" stroke={symbolstroke} strokeMiterlimit="10" strokeWidth="2.2"/>
    <circle cx="9.88" cy="22.12" r="1.88" fill="none" stroke={symbolstroke} strokeMiterlimit="10" strokeWidth="2.2"/>
    <circle cx="22" cy="16" r="2" fill="none" stroke={symbolstroke} strokeMiterlimit="10" strokeWidth="2.2"/>
</g>*/



// WEBPACK FOOTER //
// ./src/js/components/ShareWidget/ShareWidget.jsx